export const MARK_FONT_SIZE = 'mark-font-size';
export const MARK_TEXT_COLOR = 'mark-text-color';
export const MARK_TEXT_SELECTION = 'mark-text-selection';
